import React, { useState, useEffect, useRef, useMemo } from 'react'
import isNull from '../../../utils/NullChecking';
import { ServerRequestProtected, ServerRequestPublic } from '../../../utils/ServerDataRequest';
import NotificationHandler from '../../../utils/NotificationHandler';
import { enumUtil } from '../../../utils/Enum';
import GroupMedia from './GroupMedia';
import ViewProfile from './ViewProfile';
import handleCopyText from '../../shared/CopyData';
import { PDF, Textfile } from '../../shared/IconsComponent/icons';
import EmojiPicker from 'emoji-picker-react';
import ReactionBar from './ReactionBar';
import { saveAs } from "file-saver"
const UserChat = ({ setmainActivetab, senderUserID, senderUserName, receiverUserName, receiverUserID, PracticeID, connection, ForwardedMesg, forawardedMessage, ClearForwardMesg, userImage }) => {
    const [rightMenu, setRightMenu] = useState(false);
    const API_URL = enumUtil.controller.Messages
    const API_URL_Messages = enumUtil.controller.Messages
    const API_URL_Wasabi = enumUtil.controller.Wasabi
    const messageListRef = useRef(null);
    const [isAutoScrollEnabled, setIsAutoScrollEnabled] = useState(true);
    const [Message, setMessage] = useState('')
    const [Messages, setMessages] = useState([])
    const [FileInput, setFileInput] = useState('')
    const [FileType, setFileType] = useState('')
    const [offSet, setOffSet] = useState("0")
    const [isLoading, setisLoading] = useState(false)
    const [isNullFileInput, setisNullFileInput] = useState(false)
    // Function to handle scrolling to the bottom
    const scrollToBottom = () => {
        if (messageListRef.current) {
            messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
        }
    };
    // Scroll to bottom when Messages change and auto-scroll is enabled
    useEffect(() => {
        if (isAutoScrollEnabled) {
            scrollToBottom();
        }
    }, [Messages, isAutoScrollEnabled]);

    const FetchOldMesgs = () => {
        setisLoading(true)
        const messageList = messageListRef.current;
        const prevScrollHeight = messageList.scrollHeight;
        const prevScrollTop = messageList.scrollTop;
        ServerRequestProtected(API_URL + "/FetchOldMessages", 'post', {
            "Data": {
                "SenderID": senderUserID,
                "ReceiverID": receiverUserID + "",
                "Offset": offSet + "",
                "PracticeID": PracticeID + ""
            }
        }).then((response) => {
            setisLoading(false)
            setMessages(prevMessages => [...response, ...prevMessages]);
            setTimeout(() => {
                const newScrollHeight = messageList.scrollHeight;
                messageList.scrollTop = prevScrollTop + (newScrollHeight - prevScrollHeight);
            }, 0);
        }).catch((error) => {
            setisLoading(false)
        })
    }
    useEffect(() => {
        FetchOldMesgs()
    }, [offSet])
    useEffect(() => {
        // if (Messages && Messages.length > 0) {
        //     let latestMessage = Messages[Messages.length - 1]
        //     if (latestMessage.user === `${receiverUserID + '_' + receiverUserName}`) {
        //         let newMeasg = [...Messages]
        //         newMeasg.push(latestMessage)
        //         setMessages(newMeasg)
        //     }
        // }
    }, [Messages])
    const handleScroll = () => {
        const { scrollTop, scrollHeight, clientHeight } = messageListRef.current;
        setIsAutoScrollEnabled(scrollTop + clientHeight >= scrollHeight);
        if (scrollTop === 0) {
            setOffSet(Messages.length)
        } else if (scrollTop + clientHeight === scrollHeight) {
        }
    };
    const handleSend = () => {
        setShowEmojiPicker(false)
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert midnight (0) to 12
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        let time = `${formattedHours}:${formattedMinutes} ${ampm}`
        // let obj = {
        //     user: `${senderUserID + '_' + senderUserName}`,
        //     message: Message,
        //     CreatedTime: time
        // }
        // let newMeasg = [...Messages]
        // newMeasg.push(obj)
        setMessage('')
        // setMessages(newMeasg)
        if (!isNull(FileInput) && !isNull(Messages)) {
            setisLoading(true)
            if (FileType === 'image/png' || FileType === 'image/jpeg' || FileType === 'image/jpg') {
                ServerRequestProtected(API_URL_Messages + "/UploadImage", 'post', {
                    "sender": `${senderUserID + '_' + senderUserName}`,
                    "receiver": `${receiverUserID + '_' + receiverUserName}`,
                    "filename": Message,
                    "base64": FileInput,
                    "PracticeID": PracticeID + ""
                }).then((response) => {
                    setisLoading(false)
                    let obj = {
                        user: `${senderUserID + '_' + senderUserName}`,
                        message: response.uploaded_file_link,
                        CreatedTime: time
                    }
                    let newMeasg = [...Messages]
                    newMeasg.push(obj)
                    setMessage('')
                    setFileInput(null)
                    // setMessages(newMeasg)
                    sendImage(response.uploaded_file_link, replyMessage ? replyMessage.MessageID + "" : '')
                }).catch((error) => {
                    setisLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
            } else {
                ServerRequestProtected(API_URL_Messages + "/UploadFile", 'post', {
                    "sender": `${senderUserID + '_' + senderUserName}`,
                    "receiver": `${receiverUserID + '_' + receiverUserName}`,
                    "filename": Message,
                    "base64": FileInput,
                    "PracticeID": PracticeID + ""
                }).then((response) => {
                    setisLoading(false)
                    let obj = {
                        user: `${senderUserID + '_' + senderUserName}`,
                        message: response.path,
                        CreatedTime: time,
                        FileExtension: Message
                    }
                    let newMeasg = [...Messages]
                    newMeasg.push(obj)
                    setMessage('')
                    setFileInput(null)
                    // setMessages(newMeasg)
                    sendFile(response.path, replyMessage ? replyMessage.MessageID + "" : '')
                }).catch((error) => {
                    setisLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
            }
        } else {
            if (isNull(Message)) {
                setisNullFileInput(true)
                setTimeout(() => {
                    setisNullFileInput(false)
                }, 3000);
            } else {
                let obj = {
                    user: `${senderUserID + '_' + senderUserName}`,
                    message: Message,
                    CreatedTime: time,
                    ParentID: replyMessage ? replyMessage.MessageID : null
                }
                let newMeasg = [...Messages]
                newMeasg.push(obj)
                setMessage('')
                // setMessages(newMeasg)
                // console.log(Message, replyMessage ? replyMessage.MessageID + "" : '', false, time);

                sendMessageToOne(Message, replyMessage ? replyMessage.MessageID + "" : '', false, time) // send message to single user
            }

        }
        // sendMessageToAll(Message) // send message to group
    }
    const OnEnter = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            // let obj = {
            //     user: `${senderUserID + '_' + senderUserName}`,
            //     message: Message,
            //     ParentID: replyMessage ? replyMessage.MessageID : null
            // }
            // let newMeasg = Messages
            // newMeasg.push(obj)
            // setMessage('')
            // setMessages(newMeasg)
            // // sendMessageToAll(Message) // send message to group
            // sendMessageToOne(Message, replyMessage ? replyMessage.MessageID + "" : '') // send message to single user
            handleSend()
        }
    }
    const handleFileChange = (e) => {
        const { files } = e.target;
        const file = files[0];
        setMessage(file.name)
        const fileType = file.type
        setFileType(fileType)
        if (fileType === 'image/png' || fileType === 'image/jpeg' || fileType === 'image/jpg') {
            const reader = new FileReader();
            reader.onloadend = (event) => {
                setFileInput(event.target.result.split("base64,")[1])
            };
            reader.readAsDataURL(file);
        } else {
            const reader = new FileReader();
            reader.onloadend = (event) => {
                setFileInput(event.target.result.split("base64,")[1])
            };
            reader.readAsDataURL(file);
        }
        // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        // application/pdf
    };
    useEffect(() => {
        if (connection) {
            connection.on("ReceiveMessage", (user, message, ParentID, messageID, IsForwarded, parrentMsg, parentMsgSenderID, createdTime, IsMessageSent, IsMessageDelivered) => {
                const newMessage = {
                    user,
                    message,
                    ParentID,
                    MessageID: messageID,
                    FileExtension: message,
                    ParentMsg: parrentMsg ? parrentMsg : null,
                    IsForwarded: IsForwarded,
                    CreatedTime: createdTime,
                    ParrentMesgSenderID: parentMsgSenderID ? parentMsgSenderID : null,
                    IsMessageSent: IsMessageSent,
                    IsMessageDelivered: IsMessageDelivered
                };
                if (!IsForwarded) {
                    setMessages(prevMessages => [...prevMessages, newMessage]);
                }
            });
            connection.on("ReceiveMessageReaction", (user, message, msgID) => {
                setMessages(prevMessages =>
                    prevMessages.map(item =>
                        item.MessageID + "" === msgID + ""
                            ? { ...item, Reaction: message }
                            : item
                    )
                );
            });
            return () => {
                connection.off("ReceiveMessage");
                connection.off("ReceiveMessageReaction");
            };
        }
    }, [connection]);
    const sendMessageToOne = (message, ParentID, forwarded, time) => {
        let forwardedData = forwarded ? 'true' : 'false';
        if (connection) {
            connection.invoke("SendMessageToGroup", receiverUserID + "", message, ParentID, forwardedData, time).catch(err => console.error(err.toString()));
        }
        setReplyMessage(null)
    };
    const sendImage = (img, ParentID, forwarded) => {
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert midnight (0) to 12
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        let time = `${formattedHours}:${formattedMinutes} ${ampm}`
        let forwardedData = forwarded ? 'true' : 'false';
        if (connection) {
            connection.invoke("SendImageToGroup", receiverUserID + "", img, ParentID, forwardedData, time).catch(err => console.error(err.toString()));
        }
    }
    const sendFile = (file, ParentID, forwarded) => {
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert midnight (0) to 12
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        let time = `${formattedHours}:${formattedMinutes} ${ampm}`
        let forwardedData = forwarded ? 'true' : 'false';
        if (connection) {
            connection.invoke("SendFileToGroup", receiverUserID + '', file, ParentID, forwardedData, time).catch(err => console.error(err.toString()));
        }
    }
    // left menu (for copy, reply , delete,  or others)
    const [activeMenuIndex, setActiveMenuIndex] = useState(null);
    const menuRef = useRef();
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setActiveMenuIndex(null); // close only on outside clicks
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const menuRefRight = useRef();
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRefRight.current && !menuRefRight.current.contains(event.target)) {
                setRightMenu(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    // main screen (for chat, group, or others)
    // groupMedia (for group media)
    // searchChat for to search user messages
    // viewProfile (for user profile)
    const [activeChatScreen, setActiveChatScreen] = useState('main')
    const [searchedMessages, setSearchedMessages] = useState([])
    const [searchedvalue, setSearchedValue] = useState('')
    const searchInChat = (e) => {
        let value = e.target.value
        setSearchedValue(value)
        if (value.length > 1) {
            ServerRequestProtected(API_URL_Messages + "/SearchInChat", 'post', {
                'TableName': enumUtil.enumAPITableName.Messages,
                "SearchCriteria": {
                    "SearchText": value,
                    "ReceiverID": receiverUserID + "",
                }
            }).then((response) => {
                setisLoading(false)
                setSearchedMessages(response)
            }).catch((error) => {
                setisLoading(false)
                setSearchedMessages([])
            })
        }
    }
    const backToMain = () => {
        setActiveChatScreen('main');
        setSearchedValue('')
        setSearchedMessages([])
    }
    const ClearAllChat = () => {
        ServerRequestProtected(API_URL_Messages + "/ClearChat", 'post', {
            'TableName': enumUtil.enumAPITableName.Messages,
            "SearchCriteria": {
                "ReceiverID": receiverUserID + "",
            }
        }).then((response) => {
            setisLoading(false)
            setMessages([])
        }).catch((error) => {
            setisLoading(false)
            // setMessages([])
        })
        setRightMenu(false)
    }
    // Copy message to clipboard
    const [copiedText, setCopiedText] = useState(false);
    const handleCopy = (message) => {
        handleCopyText(message);
        setCopiedText(true);
        setTimeout(() => {
            setCopiedText(false);
            setActiveMenuIndex(null); // Close the menu after copying
        }, 500)
    }
    // Reply message
    const inputRef = useRef(null);
    const [replyMessage, setReplyMessage] = useState(null);
    const handleReply = (item, type) => {
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
        setReplyMessage({ ...item, name: type === 'rec' ? receiverUserName : 'You' });
        setTimeout(() => {
            setActiveMenuIndex(null); // Close the menu after copying
        }, 300)
        // setActiveMenuIndex(null); // Close the menu after copying
    }
    const viewReplyMessage = (message, data) => {
        if (message.includes('Images')) {
            return <div className="d-flex align-items-center gap-1">
                <i className='icon-image fs-10'></i>
                <p className='text fs-10'>{data.FileExtension ? data.FileExtension.split('.')[1] : data.FileExtension}</p>
            </div>
        } else if (message.includes('files')) {
            return <div className=''>
                <div className="d-flex align-items-center gap-1">
                    {getFileIconSmall(data.FileExtension)}
                    {/* <PDF classes={'fs-10'} /> */}
                    {/* <i className='icon-excel fs-10 text-success'></i>
                    <span class="icon-word fs-10"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                    <i className='icon-image fs-10'></i>
                    <Textfile classes={'fs-10'} /> */}
                    <p className='text fs-10'>{data.FileExtension ? data.FileExtension.split('.')[1] : data.FileExtension}</p>
                </div>
            </div>
        } else {
            return <p className='text fs-10 multiline-ellipsis'>{message}</p>
        }
    }
    const handleChangeInput = (e) => {
        if (isNull(e.target.value)) {
            setFileInput(null);
        }
        setMessage(e.target.value);
    }
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [receiverUserID]);
    const inputFieldView = () => {
        return (
            <div className='chatbox__content'>
                <div className="chatbox__content__bottom pb-0">
                    <div className={`w-100 ${!isNull(replyMessage) ? 'za-reply p-2 w-100' : ''} ${false ? "za-reply p-2 w-100 ar-attachment" : ""}`}>
                        {replyMessage && (
                            <div className='d-flex justify-content-between align-items-center reply-content gap-2'>
                                <div className=''>
                                    {replyMessage.message?.includes('Images') ? (
                                        <div className='za-guidelines-new d-flex flex-column gap-01 za-file-reply'>
                                            <p className='text font-m fs-10 chatbot-c-green'>{replyMessage.name}</p>
                                            <div className="d-flex align-items-center gap-1">
                                                <i className='icon-image fs-10'></i>
                                                <p className='text fs-10 singleLine-ellispis '>
                                                    {replyMessage.FileExtension ? replyMessage.FileExtension.split('.')[0] : ''}
                                                </p>
                                            </div>
                                            <div>
                                            </div>
                                        </div>
                                    ) : replyMessage.message?.includes('files') ? (
                                        <div className='za-guidelines-new d-flex flex-column gap-01 za-file-reply'>
                                            <p className='text font-m fs-10 chatbot-c-green'>{replyMessage.name}</p>
                                            <div className="d-flex align-items-center gap-1">
                                                {getFileIconSmall(replyMessage.FileExtension)}
                                                {/* <PDF classes={'fs-10'} /> */}
                                                {/* <i className='icon-excel fs-10 text-success'></i> */}
                                                {/* <span class="icon-word fs-10"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span> */}
                                                {/* <i className='icon-image fs-10'></i> */}
                                                {/* <Textfile classes={'fs-10'} /> */}
                                                <p className='text fs-10 singleLine-ellispis'>
                                                    {replyMessage.FileExtension ? replyMessage.FileExtension.split('.')[0] : ''}
                                                </p>
                                            </div>
                                            <div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className='simple-message'>
                                            <p className='text fs-11 font-m za-clr-green'>{replyMessage.name} <span className='text fs-10'>{replyMessage.CreatedDate} {replyMessage.CreatedTime}</span></p>
                                            <p className='text fs-10 ar-light-color singleLine-ellispis'> {decodeUnicodeString(replyMessage.message)}</p>
                                        </div>
                                    )}
                                </div>
                                <i
                                    className='dark-clr fs-18 fw-900 icon-x-cros'
                                    onClick={() => setReplyMessage(null)}
                                    style={{ cursor: 'pointer' }}
                                ></i>
                            </div>
                        )}

                        {/* Design for Attchment  */}

                        {/* <div className="reply-content">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-2 w-100 ">
                                    <PDF classes={'fs-21'} />
                                    // <i className='icon-excel fs-21 text-success'></i>
                                    // <span class="icon-word fs-21"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                                    // <i className='icon-image fs-21'></i>
                                    // <Textfile classes={'fs-21'} />

                                    <div className="">
                                        <p className="text fs-11 singleLine-ellispis">Guidelines new.png</p>
                                        <div className="d-flex align-items-center gap-15">
                                            <p className="text ar-light-color ">18 Mb</p>
                                            <p className="text ar-light-color ">PNG</p>

                                        </div>
                                    </div>
                                </div>
                                <i className='dark-clr fs-18 fw-900 icon-x-cros'></i>
                            </div>

                        </div> */}


                        <div className="chatbox__content__bottom__input flex-column align-items-start row-gap-5">
                            <div className="d-flex align-items-center w-100 h-100 gap-1">
                                <button className="btn-icon-transparent" onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                                    <i className="icon-smile"></i>
                                </button>

                                {/* Single file selection */}

                                {/* <div className="ar-file-attach d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center gap-2">
                                        <PDF classes={'fs-10'} />
                                        <i className='icon-excel fs-10 text-success'></i>
                                        <span class="icon-word fs-10"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                                        <i className='icon-image fs-10'></i>
                                        <Textfile classes={'fs-10'} />

                                        <p className='singleLine-ellispis text fs-10'>Guidelines new.png</p>
                                    </div>
                                    <i className='dark-clr fs-11 lh-8 fw-900 icon-x-cros cursor-pointer'></i>
                                </div> */}

                                <input
                                    type="text"
                                    className='form-control'
                                    ref={inputRef}
                                    value={Message}
                                    onChange={handleChangeInput}
                                    onKeyDown={OnEnter}
                                    placeholder='Type a new message'
                                />
                                <input
                                    type="file"
                                    id="fileInput"
                                    name="fileInput"
                                    // ref={inputRef}
                                    accept=".pdf, .xls, .xlsx, .jpg, .jpeg, .png"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                />

                                <i className='icon icon-gallery'></i>
                                <FileInputButton onChange={handleFileChange} />
                                {showEmojiPicker && (
                                    <div >
                                        <EmojiPicker onEmojiClick={handleEmojiClick} />
                                    </div>
                                )}
                            </div>

                            {/* <div className="ar-multiple-file d-flex flex-wrap row-gap-5 gap-2">
                                <div className="ar-file-attach d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center gap-2">
                                        <PDF classes={'fs-10'} />
                                        <i className='icon-excel fs-10 text-success'></i>
                                        <span class="icon-word fs-10"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                                        <i className='icon-image fs-10'></i>
                                        <Textfile classes={'fs-10'} />

                                        <p className='text fs-10'>Guidelines new.png</p>
                                    </div>
                                    <i className='dark-clr fs-11 lh-8 fw-900 icon-x-cros cursor-pointer'></i>
                                </div>
                                <div className="ar-file-attach d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center gap-2">
                                        <PDF classes={'fs-10'} />
                                        <p className='text fs-10'>Guidelines new.png</p>
                                    </div>
                                    <i className='dark-clr fs-11 lh-8 fw-900 icon-x-cros cursor-pointer'></i>
                                </div>
                            </div> */}

                        </div>

                    </div>
                    <button className="btn send-btn" onClick={handleSend}>
                        <i className="icon-fly"></i>
                        <i className="icon-send-svgrepo-com fs-24 text-white"></i>
                    </button>
                </div>
            </div>
        )
    }
    const getFileIcon = (fileName) => {
        const extension = fileName?.split('.').pop()?.toLowerCase();
        switch (extension) {
            case 'pdf': return <PDF classes={'fs-30'} />;
            case 'xls':
            case 'xml':
            case 'xlsx': return <i className='icon-excel fs-30 text-success'></i>;
            case 'doc':
            case 'docx': return <span class="icon-word fs-28"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>;
            case 'jpg':
            case 'jpeg':
            case 'png': return <i className='icon-image fs-30'></i>;
            default: return <Textfile classes={'fs-30'} />;
        }
    };
    const getFileIconSmall = (fileName) => {
        const extension = fileName?.split('.').pop()?.toLowerCase();
        switch (extension) {
            case 'pdf': return <PDF classes={'fs-10'} />;
            case 'xls':
            case 'xml':
            case 'xlsx': return <i className='icon-excel fs-10 text-success'></i>;
            case 'doc':
            case 'docx': return <span class="icon-word fs-10"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>;
            case 'jpg':
            case 'jpeg':
            case 'png': return <i className='icon-image fs-10'></i>;
            default: return <Textfile classes={'fs-10'} />;
        }
    };
    const FileInputButton = ({ onChange }) => {
        const inputRefFile = useRef();

        const handleClick = () => {
            inputRefFile.current.value = ''; // Reset input
            inputRefFile.current.click();
        };

        return (
            <>
                {true ?
                    <>
                        <button type="button" className="btn-icon-transparent" onClick={handleClick}>
                            <i className="icon-Icon-metro-attachment"></i>
                        </button>
                        <input
                            type="file"
                            ref={inputRefFile}
                            style={{ display: 'none' }}
                            onChange={onChange}
                            accept=".pdf,.xls,.xlsx,.doc,.docx,.jpg,.jpeg,.png,.txt"
                        />
                    </>
                    :
                    <div className="ar-small-loader justify-content-center last_loader">
                        <div className="circle circle1"></div>
                        <div className="circle circle2"></div>
                    </div>}
            </>
        );
    };
    const [viewSelectedImage, setViewSelectedImage] = useState();
    const closeImageView = () => {
        setViewSelectedImage();
    }
    const openImageView = (image) => {
        setViewSelectedImage(image);
    }
    const handleForward = (item) => {
        ForwardedMesg(item)
    }
    useEffect(() => {
        if (!isNull(forawardedMessage?.MessageID)) {
            if (isNull(forawardedMessage.FileExtension) || forawardedMessage.FileExtension === "text") {
                sendMessageToOne(forawardedMessage.message, '', true) // send message to single user
            } else if (forawardedMessage.FileExtension.includes('jpg') || forawardedMessage.FileExtension.includes('png') || forawardedMessage.FileExtension.includes('jpeg')) {
                sendImage(forawardedMessage.message, '', true) // send image to single user
            } else if (forawardedMessage.FileExtension.includes('pdf') || forawardedMessage.FileExtension.includes('xls') || forawardedMessage.FileExtension.includes('xlsx') || forawardedMessage.FileExtension.includes('doc') || forawardedMessage.FileExtension.includes('docx')) {
                sendFile(forawardedMessage.message, '', true) // send file to single user
            }
        }
    }, [forawardedMessage]);

    // emoji picker
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const handleEmojiClick = (emojiData) => {
        setMessage((prev) => prev + emojiData.emoji);
    };

    const decodeUnicodeString = (str) => {
        try {
            // If string has double-escaped unicode like \\uD83D\\uDE04
            if (str.includes('\\u')) {
                return JSON.parse(`"${str}"`);
            }
            return str;
        } catch (e) {
            return str;
        }
    }


    // date formatting function
    // Add this date formatting function
    const formatMessageDate = (dateString) => {
        const messageDate = new Date(dateString);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        // Reset hours for comparison
        const resetTime = (date) => {
            date.setHours(0, 0, 0, 0);
            return date;
        };

        if (resetTime(messageDate).getTime() === resetTime(today).getTime()) {
            return 'Today';
        } else if (resetTime(messageDate).getTime() === resetTime(yesterday).getTime()) {
            return 'Yesterday';
        } else {
            return messageDate.toLocaleDateString('en-US', {
                weekday: 'short',
                day: 'numeric',
                month: 'long'
            });
        }
    };

    // Update the groupMessagesByDate function
    const groupMessagesByDate = (messages) => {
        const grouped = {};
        messages.forEach(message => {
            // Use CreatedDate if available, otherwise use current date
            const dateStr = formatMessageDate(message.CreatedDate || new Date());

            if (!grouped[dateStr]) {
                grouped[dateStr] = [];
            }
            grouped[dateStr].push(message);
        });
        return grouped;
    };
    const groupedMessages = useMemo(() => groupMessagesByDate(Messages), [Messages]);
    const groupedSearchMessages = useMemo(() => groupMessagesByDate(searchedMessages), [searchedMessages]);


    const [msgReactions, setMsgReactions] = useState(null);
    const handleSendReaction = (messageId, emoji, type) => {
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert midnight (0) to 12
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        let time = `${formattedHours}:${formattedMinutes} ${ampm}`
        if (connection) {
            connection.invoke("SendReactionToGroup", type === 'sen' ? senderUserID : receiverUserID + "", emoji, messageId + "", time).catch(err => console.error(err.toString()));
        }
        setMsgReactions(null) // reset reactions after sending
    }

    const DownloadFile = (data) => {
        setisLoading(true)
        ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
            "BucketPath": data,
        }, "Download",).then((response) => {
            let blob = new Blob([response]);
            saveAs(blob, data ? data.split('/').pop() : 'downloaded_file');
            setisLoading(false)
        }).catch((error) => {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            setisLoading(false)
        })
    }
    const BackToMainScreen = () => {
        // if (connection) {
        //     connection.invoke("UpdateChatforUser", receiverUserID + "")
        //         .then((response, a, b, c) => {
        //         })
        //         .catch(err => console.error(err.toString()));
        // }
        setmainActivetab('1');
        ClearForwardMesg()
    }

    const isMessageSeen = (item) => {
        if (item.IsMessageSeen === true || item.IsMessageSeen === 'true') {
            return <i className="bi bi-check2-all fs-14 lh-14 za-blue-clr"></i>
        } else if (item.IsMessageDelivered === true || item.IsMessageDelivered === 'true') {
            return <i className="bi bi-check2-all fs-14 lh-14"></i>
        } else if (item.IsMessageSent === true || item.IsMessageSent === 'true') {
            return <i className="bi bi-check2 fs-14 lh-14"></i>
        }
    }
    const handleDeleteSingleMesg = (data) => {
        console.log(data);

        setisLoading(true)
        ServerRequestProtected(API_URL_Messages + "/DeleteMessage", 'post', {
            "TableName": enumUtil.enumAPITableName.Messages,
            "ID": data.MessageID + "",
        }).then((response) => {
            setisLoading(false)
            setMessages(prevMessages => prevMessages.filter(item => item.MessageID !== data.MessageID));
            setActiveMenuIndex(null); // Close the menu after deleting
        }).catch((error) => {
            setisLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        }
        )
    }
    return (
        <div className='za-new-conversation-screen view-profile'>
            {viewSelectedImage ?
                <div className="image-preview">
                    <div className="image-preview-content">
                        <div className="d-flex align-items-center justify-content-between gap-10 pb-2">
                            <p className='text drk-clr'>Image.png</p>
                            <div className="d-flex align-items-center gap-1">
                                <i className="icon-new-download fs-15"></i>
                                <i className="icon-x-cros fs-20 dark-clr fw-900" onClick={closeImageView}></i>
                            </div>
                        </div>
                        <img src={viewSelectedImage} alt="" />
                    </div>
                </div>
                : null}
            {activeChatScreen === 'searchChat' ?
                <div className='za-new-conversation-screen created-group position-relative za-search'>
                    <div className='mb-12'>
                        <div className='d-flex za-header gap-2'>
                            <span className='icon-box d-flex align-items-center justify-content-center'>
                                <i className='icon-arrow-left2' onClick={backToMain}></i>
                            </span>
                            <div className='chatbot-input w-100'>
                                <div className='input position-relative'>
                                    <input
                                        type="text"
                                        className="form-control px-2"
                                        name="searchedvalue"
                                        id="searchedvalue"
                                        placeholder='Search Conversation'
                                        value={searchedvalue}
                                        onChange={searchInChat}
                                    />
                                    <i className='icon-Group-3311 position-absolute translate-middle-y top-50' onClick={() => setSearchedValue('')}></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : activeChatScreen === 'viewProfile' ?
                    <div className='mb-12'>
                        <div className='d-flex gap-1 align-items-center za-header '>
                            <span className='icon-box d-flex align-items-center justify-content-center'>
                                <i className='icon-arrow-left2' onClick={backToMain}></i>
                            </span>
                            <p className='heading fs-14'>Profile</p>
                        </div>
                    </div> : activeChatScreen === 'groupMedia' ?
                        <div className='d-flex gap-1 align-items-center justify-content-between za-header'>
                            <span className='icon-box d-flex align-items-center justify-content-center' onClick={backToMain}><i className='icon-arrow-left2'></i></span>
                            <div className=' d-flex gap-1 align-items-center '>
                                <div className="img-container s-35 circle">
                                    <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                                </div>
                                <div className=''>
                                    <p className='heading fs-14'>{receiverUserName}</p>
                                </div>

                            </div>
                            <div className=''></div>
                        </div> :
                        <div className='d-flex gap-1 align-items-center justify-content-between za-header py-2 px-10'>
                            <span className='icon-box d-flex align-items-center justify-content-center' onClick={() => BackToMainScreen()}><i className='icon-arrow-left2'></i></span>
                            <div className=' d-flex gap-1 align-items-center '>
                                <div className="img-container s-35 circle">
                                    <img src={userImage ? userImage : "https://www.w3schools.com/howto/img_avatar.png"} alt="" />
                                </div>
                                <div className=''>
                                    <p className='heading fs-14'>{receiverUserName}</p>
                                </div>
                            </div>

                            <div className='position-relative' ref={menuRefRight} >
                                <i className='icon icon-menuicon' onClick={() => { setRightMenu(!rightMenu); setActiveChatScreen('main') }}></i>
                                {rightMenu &&
                                    <div className='za-popup position-absolute d-flex flex-column p-0 bg-white shadow-none app_border za_br_light top-100'>
                                        <p className={`text fs-12 py-1 br-bottom-1 za_br_light ps-2 cursor-pointer user-select-none ${activeChatScreen === 'viewProfile' ? 'active' : ''}`}
                                            onClick={() => { setActiveChatScreen('viewProfile'); setRightMenu(false) }}>
                                            View Profile</p>
                                        <p className={`text fs-12 py-1 br-bottom-1 za_br_light ps-2 cursor-pointer user-select-none ${activeChatScreen === 'groupMedia' ? 'active' : ''}`}
                                            onClick={() => { setActiveChatScreen('groupMedia'); setRightMenu(false) }}>
                                            Group Media
                                        </p>
                                        <p className={`text fs-12 py-1 br-bottom-1 za_br_light ps-2 cursor-pointer user-select-none ${activeChatScreen === 'searchChat' ? 'active' : ''}`}
                                            onClick={() => { setActiveChatScreen('searchChat'); setRightMenu(false) }}>
                                            Search
                                        </p>
                                        {/* <p className='text fs-12 py-1 ps-2 cursor-pointer user-select-none' onClick={() => ClearAllChat()}>Clear Chat</p> */}
                                    </div>
                                }
                            </div>
                        </div>
            }
            {/* chat messages */}
            {activeChatScreen === 'main' || activeChatScreen === 'searchChat' ?
                <div className='za-new-conversation-screen created-group za-reply-msg-screen position-relative bg-transparent'>
                    {isLoading ?
                        <div className="ar-small-loader justify-content-center last_loader position-absolute start-50 translate-middle-x">
                            <div className="circle circle1"></div>
                            <div className="circle circle2"></div>
                        </div>
                        : null
                    }
                    {copiedText ? (
                        <p className={`xsm_text  copied_text d-block text-nowrap user-select-none translate-middle-x start-50`} >Copied to clipboard</p>
                    ) : (
                        <></>
                    )}
                    {isNullFileInput ?
                        <p className={`xsm_text  copied_text d-block text-nowrap user-select-none translate-middle-x start-50`} >Please type a message or select a file to send</p> : null}


                    <div className=' za-chat-message px-10 hover-scrollbar bg-transparent' ref={messageListRef} onScroll={handleScroll}>
                        {/* <p className='text fs-10 light-clrs mb-2 text-center'>Mon,22 April</p> */}
                        <div className="d-flex flex-column gap-15">
                            {searchedMessages.length > 0 ? searchedMessages.map((item, index) => {
                                return (
                                    <>
                                        {item.user + "" === senderUserID + "" ?
                                            <div className='chat-bot-message-sender d-flex flex-column gap-1 align-items-end mb-2 mt-4'>
                                                {/* {isFirstMessageOrUserChanged && (
                                        <h3>{userName}</h3>
                                    )} */}
                                                {/* left menu (for copy, reply , delete,  or others)  */}
                                                {/* + sender Message */}
                                                <div className="d-flex justify-content-between align-items-center w-100 za-message-sender">
                                                    <div className='position-relative' ref={menuRef} >
                                                        <i className=' icon-menuicon fs-11' onClick={() => setActiveMenuIndex(activeMenuIndex === index ? null : index)}></i>
                                                        {activeMenuIndex === index && (
                                                            <div className='za-popup position-absolute d-flex flex-column'>
                                                                <p className='text fs-12 pb-2 br-bottom-1 br-clr active'>Copy</p>
                                                                <p className='text fs-12 py-2 br-bottom-1 br-clr'>Reply</p>
                                                                <p className='text fs-12 py-2 br-bottom-1 br-clr'>Forward</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {!isNull(item.message) && item.message.includes('Images') ? (
                                                        <span> <img style={{ width: '184px', height: '139px', objectFit: 'cover', borderRadius: '5px' }} src={item.message} alt="Image" /> </span>
                                                    ) : !isNull(item.message) && item.message.includes('files') ?
                                                        <div className='za-guidelines-new d-flex justify-content-center align-items-center gap-1 mt-2'>
                                                            <div>
                                                                <span class="icon-pdf-chatbot fs-30"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span></span>
                                                            </div>
                                                            <div className=''>
                                                                <div className=''>
                                                                    <div className='col-12' >
                                                                        <p className='text font-m fs-13'>{item.FileExtension ? item.FileExtension.split('.')[0] : item.FileExtension}</p>
                                                                    </div>
                                                                </div>
                                                                <div className='d-flex'>
                                                                    <div className='col-md-8'>
                                                                        <p className='text fs-10 text-start'>18MB</p>
                                                                    </div>
                                                                    <div className='col-md-4'>
                                                                        <p className='text fs-10'>{item.FileExtension ? item.FileExtension.split('.')[1] : item.FileExtension}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> : (
                                                            <p className='text ps-12 bg-text-sender'>{item.message}</p>
                                                        )}
                                                    {/* <p className='text ps-12 bg-text-sender'>Hello</p> */}
                                                </div>
                                                {/* + sender Message  time*/}
                                                <p className='text fs-10 ar-light-color d-flex justify-content-center align-items-center gap-1'>{!isNull(item.CreatedTime) ? item.CreatedTime : ''} <i className="bi bi-check-all fs-18 za-blue-clr"></i></p>
                                                {/* <p className='text fs-10 ar-light-color d-flex justify-content-center align-items-center gap-1'>11:46<i className="bi bi-check-all fs-18 za-blue-clr"></i></p> */}
                                            </div>
                                            : item.user + "" === receiverUserID + "" ?
                                                <>
                                                    <div className='za-message-receiver d-flex justify-content-between align-items-center za-message-sender'>
                                                        {/* {isFirstMessageOrUserChanged && (
                                        <h3>{userName}</h3>
                                    )} */}
                                                        <div className='chat-bot-message-receiver d-flex justify-content-start gap-1'>
                                                            <div className="img-container s-35 circle">
                                                                <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                                                            </div>
                                                            <div className=' d-flex align-items-center gap-1'>
                                                                <div className='bg-text-receiver text-start'>
                                                                    {/* <p className='text font-m fs-11 za-clr-green'>Bonnie Green</p> */}
                                                                    {/* other user name with there chat (group) */}
                                                                    {!isNull(item.message) && item.message.includes('Images') ? (
                                                                        <span> <img style={{ width: '184px', height: '139px', objectFit: 'cover', borderRadius: '5px' }} src={item.message} alt="Image" /> </span>
                                                                    ) : !isNull(item.message) && item.message.includes('files') ?
                                                                        <div className='za-guidelines-new d-flex justify-content-center align-items-center gap-1 mt-2'>
                                                                            <div>
                                                                                <span class="icon-pdf-chatbot fs-30"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span></span>
                                                                            </div>
                                                                            <div className=''>
                                                                                <div className=''>
                                                                                    <div className='col-12' >
                                                                                        <p className='text font-m fs-13'>{item.FileExtension.split('.')[0]}</p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className='d-flex'>
                                                                                    <div className='col-md-8'>
                                                                                        <p className='text fs-10 text-start'>18MB</p>
                                                                                    </div>
                                                                                    <div className='col-md-4'>
                                                                                        <p className='text fs-10'>{item.FileExtension.split('.')[1]}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div> : (
                                                                            <p className='text fs-12'>{item.message}</p>
                                                                        )}
                                                                </div>
                                                                <i className='icon-emoji fs-10'></i>
                                                            </div>
                                                        </div>
                                                        <div className='position-relative' ref={menuRef} >
                                                            <i className=' icon-menuicon fs-11' onClick={() => setActiveMenuIndex(activeMenuIndex === index ? null : index)}></i>
                                                            {activeMenuIndex === index &&
                                                                <div className='za-popup position-absolute d-flex flex-column'>
                                                                    <p className='text fs-12 pb-2 br-bottom-1 br-clr active'>Copy</p>
                                                                    <p className='text fs-12 py-2 br-bottom-1 br-clr'>Reply</p>
                                                                    <p className='text fs-12 py-2 br-bottom-1 br-clr'>Forward</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    {/* forwarded if */}
                                                    {/* <div className=''>
                                    <p className='text fs-9 light-clrs text-end'> <i className='icon-forwarded'></i>Forwarded</p>
                                </div> */}
                                                    <p className='text fs-10 ar-light-color mt-1 mb-1'>{!isNull(item.CreatedTime) ? item.CreatedTime : ''} </p>
                                                </>
                                                : null
                                        }
                                    </>
                                )
                            }) : (
                                Object.entries(groupedMessages).map(([date, dateMessages]) => (
                                    <React.Fragment key={date}>
                                        <p className='text fs-10 light-clrs mb-2 text-center'>{date}</p>
                                        {dateMessages.map((item, date) => {
                                            // const isFirstMessageOrUserChanged = index === 0 || dateMessages[index - 1].user !== item.user;
                                            const isSender = item?.user + "" === senderUserID + "" ? true : false
                                            const isReceiver = item?.user + "" === receiverUserID + "" ? true : false
                                            const file = !isNull(item?.FileExtension) ? item?.FileExtension.split('.')[1] : null
                                            const isFile = !isNull(item?.FileExtension) && (file === 'pdf' || file === 'doc' || file === 'docx' || file === 'xls' || file === 'xlsx' || file === 'txt') ? true : false
                                            // const isImage = !isNull(item.FileExtension) && file === 'jpg' || file === 'jpeg' || file === 'png' ? true : false
                                            const isImage = item?.message?.includes('Images') ? true : false

                                            // const isReply = !isNull(item.ParentID) ?  Messages.find(msg => msg.MessageID + "" === item.ParentID + "") : null
                                            const isReply = !isNull(item?.ParentID) ? item?.ParentMsg : null
                                            const ReplyerName = isReply && item?.ParrentMesgSenderID + "" === senderUserID + "" ? true : false
                                            const IsForwarded = item?.IsForwarded ? true : false
                                            // let fileType = item.FileExtension ? item.FileExtension.split('.').pop() : null;
                                            // { console.log(fileType) }

                                            return (
                                                <div key={item.MessageID}>
                                                    {isSender ? (
                                                        <div className='chat-bot-message-sender'>
                                                            <div className="za-message-sender position-relative">
                                                                <div className='position-relative'  >
                                                                    {/* <div className="cursor-pointer pe-3" onClick={() => setActiveMenuIndex(activeMenuIndex === item.MessageID ? null : item.MessageID)}>
                                                                        <i className=' icon-menuicon fs-11'></i>
                                                                    </div> */}
                                                                    {/* {activeMenuIndex === item.MessageID &&
                                                                        <div className='za-popup position-absolute d-flex flex-column p-0 bg-white shadow-none app_border za_br_light' ref={menuRef}>
                                                                            <p className='text fs-12 py-1 br-bottom-1 za_br_light ps-2 cursor-pointer user-select-none' onClick={(e) => { e.stopPropagation(); handleCopy(item.message) }}>Copy</p>
                                                                            <p className='text fs-12 py-1 br-bottom-1 za_br_light ps-2 cursor-pointer user-select-none' onClick={(e) => { e.stopPropagation(); handleReply(item, 'sen') }}>Reply</p>
                                                                            <p className='text fs-12 py-1 ps-2 cursor-pointer user-select-none' onClick={() => handleForward(item)}>Forward</p>
                                                                        </div>
                                                                    } */}

                                                                </div>
                                                                <div className="d-flex justify-content-end gap-2 align-items-center">
                                                                    <p className='text fs-10 color-95 time-txt'>{!isNull(item.CreatedTime) ? item.CreatedTime : ''}
                                                                        {/* {isMessageSeen(item)} */}
                                                                    </p>
                                                                    <div className='ar-message-hover position-relative'>
                                                                        {isImage ? (
                                                                            <span className='image-load' onClick={() => openImageView(item?.message)}>
                                                                                <img style={{ width: '184px', height: '139px', objectFit: 'cover', borderRadius: '5px' }} src={item?.message} alt="Image" />
                                                                            </span>
                                                                        ) : isFile ?
                                                                            <div className='za-guidelines-new d-flex justify-content-center align-items-center gap-1'
                                                                                onClick={() => DownloadFile(item.message)}
                                                                            >
                                                                                <div className='col-md-3'>
                                                                                    {getFileIcon(item.FileExtension)}
                                                                                </div>
                                                                                <div className='col-md-9'>
                                                                                    <div className='col-12' >
                                                                                        <p className='text font-m fs-11 text-nowrap validation_message '>
                                                                                            {item.FileExtension ? item.FileExtension.split('/').pop() : item.FileExtension}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className='d-flex align-items-center '>
                                                                                        <div className='col-md-8'>
                                                                                            <p className='text fs-10 text-start'>18MB</p>
                                                                                        </div>
                                                                                        <div className='col-md-4'>
                                                                                            <p className='text fs-10'>{item.FileExtension ? item.FileExtension.split('.')[1] : item.FileExtension}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            : IsForwarded ?
                                                                                <div className=' bg-text-sender'>
                                                                                    <div className="d-flex gap-1 align-items-center">
                                                                                        <i class="icon-forword fs-9 opacity-75"></i>
                                                                                        <p className="text fs-10 fst-italic ar-light-color ">Forwarded</p>
                                                                                    </div>
                                                                                    <p className='text ps-12'>{item?.message}</p>
                                                                                </div>
                                                                                : (
                                                                                    <div className=' bg-text-sender'>
                                                                                        {!isNull(isReply) && (
                                                                                            <div className='d-flex align-content-center mb-1 w-100'>
                                                                                                <div className='txt-rply w-100'>
                                                                                                    <p className='text fs-9 lh-9 pb-1 za-clr-green font-m'>{ReplyerName ? 'You' : receiverUserName} </p>
                                                                                                    {/* <p className='text fs-9 lh-9'>{isReply.message}</p> */}
                                                                                                    {viewReplyMessage(isReply, item)}
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                        <p className='text ps-12'>{decodeUnicodeString(item?.message)}</p>
                                                                                    </div>
                                                                                )}
                                                                        <ReactionBar
                                                                            rowData={item}
                                                                            type='sen'
                                                                            messageId={item.MessageID}
                                                                            onReact={(messageId, emoji) => handleSendReaction(messageId, emoji, 'sen')}
                                                                            handleCopy={handleCopy}
                                                                            handleReply={handleReply}
                                                                            handleForward={handleForward}
                                                                            handleDeleteSingleMesg={handleDeleteSingleMesg}
                                                                        />
                                                                        {item.Reaction ?
                                                                            <div className="reaction-view cursor-pointer sender">
                                                                                <span className='fs-13 lh-13 position-absolute translate-middle top-50 start-50'>{decodeUnicodeString(item.Reaction)}</span>
                                                                            </div>
                                                                            : null}
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex align-items-center justify-content-end">
                                                                    {isMessageSeen(item)}
                                                                </div>
                                                                {/* <div className="d-flex align-items-center justify-content-end">
                                                                </div> */}
                                                            </div>
                                                            {/* <div className="d-flex align-items-end gap-01">
                                                                <p className='fs-13 lh-14 cursor-pointer'>{decodeUnicodeString(item.Reaction)}</p>
                                                                <p className='text fs-10 ar-light-color d-flex justify-content-center align-items-center gap-1'>{!isNull(item.CreatedTime) ? item.CreatedTime : ''} <i className="bi bi-check-all fs-18 za-blue-clr"></i></p>
                                                            </div> */}

                                                        </div>)
                                                        : isReceiver ?
                                                            (<>
                                                                <div className='za-message-receiver za-message-sender position-relative'>
                                                                    <div className='chat-bot-message-receiver'>
                                                                        {/* <div className="img-container s-35 circle">
                                                                <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" />
                                                            </div> */}
                                                                        <div className=' d-flex align-items-center gap-2'>
                                                                            <div className="ar-message-hover position-relative">
                                                                                <div className='bg-text-receiver text-start'>
                                                                                    {isImage ? (
                                                                                        <span className='image-load' onClick={() => openImageView(item.message)}> <img style={{ width: '184px', height: '139px', objectFit: 'cover', borderRadius: '5px' }} src={item.message} alt="Image" /> </span>
                                                                                    ) : isFile ?
                                                                                        <div className='za-guidelines-new d-flex align-items-center gap-1'
                                                                                            onClick={() => DownloadFile(item.message)}
                                                                                        >
                                                                                            <div className='col-md-3'>
                                                                                                {getFileIcon(item.FileExtension)}
                                                                                            </div>
                                                                                            <div className='col-md-9'>
                                                                                                <div className='col-12' >
                                                                                                    <p className='text font-m fs-11 text-nowrap validation_message'>
                                                                                                        {item.FileExtension ? item.FileExtension.split('/').pop() : item.FileExtension}
                                                                                                    </p>
                                                                                                </div>
                                                                                                <div className='d-flex align-items-center'>
                                                                                                    <div className='col-md-8'>
                                                                                                        <p className='text fs-10 text-start'>18MB</p>
                                                                                                    </div>
                                                                                                    <div className='col-md-4'>
                                                                                                        <p className='text fs-10'>{item.FileExtension ? item.FileExtension.split('.')[1] : item.FileExtension}</p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        : IsForwarded ?
                                                                                            <div className=''>
                                                                                                <div className="d-flex gap-1 align-items-center">
                                                                                                    <i class="icon-forword fs-9 opacity-75"></i>
                                                                                                    <p className="text fs-10 fst-italic ar-light-color ">Forwarded</p>
                                                                                                </div>
                                                                                                <p className='text ps-12'>{item.message}</p>
                                                                                            </div>
                                                                                            : (
                                                                                                <div>
                                                                                                    {!isNull(isReply) && (
                                                                                                        <div className='d-flex align-content-center mb-1 w-100'>
                                                                                                            <div className='txt-rply w-100'>
                                                                                                                <p className='text fs-9 font-m lh-10 pb-1'>{ReplyerName ? 'You' : receiverUserName} </p>
                                                                                                                {viewReplyMessage(isReply, item)}
                                                                                                                {/* <p className='text fs-9 lh-10'>{isReply.message}</p> */}
                                                                                                                {/* <div className="d-flex align-items-center gap-1">
                                                                                                    <PDF classes={'fs-10'} />
                                                                                                    <p className='text fs-9'>Guidelines new.pdf</p>
                                                                                                </div> */}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                    <p className='text ps-12'>{decodeUnicodeString(item.message)}</p>
                                                                                                </div>
                                                                                            )}
                                                                                </div>
                                                                                <ReactionBar
                                                                                    rowData={item}
                                                                                    type='rec'
                                                                                    messageId={item.MessageID}
                                                                                    onReact={(messageId, emoji) => handleSendReaction(messageId, emoji)}
                                                                                    handleCopy={handleCopy}
                                                                                    handleReply={handleReply}
                                                                                    handleForward={handleForward}
                                                                                    handleDeleteSingleMesg={handleDeleteSingleMesg}
                                                                                />
                                                                                {item.Reaction ?
                                                                                    <div className="reaction-view d-flex justify-content-center align-items-center cursor-pointer">
                                                                                        <span className='fs-13 lh-13'>{decodeUnicodeString(item.Reaction)}</span>
                                                                                    </div>
                                                                                    : null}
                                                                            </div>

                                                                            {/* <i className='icon-emoji fs-10' onClick={() => setMsgReactions(msgReactions === item.MessageID ? null : item.MessageID)}></i> */}
                                                                            <p className='text fs-10 color-95 time-txt'>{!isNull(item.CreatedTime) ? item.CreatedTime : ''} </p>
                                                                        </div>
                                                                        <div className="d-flex ">
                                                                            {isMessageSeen(item)}
                                                                        </div>

                                                                    </div>
                                                                    <div className='position-relative' >
                                                                        {/* <div className="cursor-pointer ps-3" onClick={() => setActiveMenuIndex(activeMenuIndex === item.MessageID ? null : item.MessageID)}>
                                                                            <i className=' icon-menuicon fs-11'></i>
                                                                        </div> */}
                                                                        {/* {activeMenuIndex === item.MessageID &&
                                                                            <div className='za-popup position-absolute d-flex flex-column p-0 bg-white shadow-none app_border za_br_light start-unset end-0' ref={menuRef}>
                                                                                <p className='text fs-12 py-1 br-bottom-1 za_br_light ps-2 cursor-pointer user-select-none' onClick={(e) => { e.stopPropagation(); handleCopy(item.message) }}>Copy</p>
                                                                                <p className='text fs-12 py-1 br-bottom-1 za_br_light ps-2 cursor-pointer user-select-none' onClick={(e) => { e.stopPropagation(); handleReply(item, 'rec') }}>Reply</p>
                                                                                <p className='text fs-12 py-1 ps-2 cursor-pointer user-select-none' onClick={() => handleForward(item)}>Forward</p>
                                                                            </div>
                                                                        } */}
                                                                    </div>
                                                                    {/* {msgReactions === item.MessageID && ( */}

                                                                    {/* )} */}
                                                                </div>
                                                                {/* <div className="d-flex align-items-end gap-01 mt-1">
                                                                    <p className='fs-13 lh-14 cursor-pointer'>{decodeUnicodeString(item.Reaction)}</p>
                                                                </div> */}
                                                            </>)
                                                            : null
                                                    }
                                                </div>
                                            )
                                        })}
                                    </React.Fragment>
                                ))
                            )}
                        </div>
                    </div>
                </div>
                : activeChatScreen === 'groupMedia' ?
                    <GroupMedia receiverUserID={receiverUserID} />
                    : activeChatScreen === 'searchChat' ?
                        <></>
                        : activeChatScreen === 'viewProfile' ?
                            <ViewProfile
                                receiverUserID={receiverUserID}
                                userImage={userImage} />
                            : null
            }

            {/*  input message box */}
            {activeChatScreen === 'main' || activeChatScreen === 'searchChat' ? inputFieldView() : null}
        </div>
    )
}

export default UserChat